export function buildUserDisplayInfo(displayName: string, email: string | undefined): string {
    return `${displayName}${email ? ` (${email})` : ''}`;
}
